export const css = {
	root: 'DXjwcIy5',
	' _key': 'ascm-theme/ascm/variants/cscp'
};

export default css;
